<div class="bar_chart">
    <div style="display: block;" *ngIf="!noData">
        <canvas #chartCanvas></canvas>
    </div>
</div>

<div *ngIf="noData" class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
   <p>No Chart Data Available!</p>
</div>
